import {createFeatureSelector, createSelector} from '@ngrx/store';
import {adapter, featureKey, State} from '../_reducers/field-type-entity.reducer';
import {FieldGroupTypeEnum} from '../_interface/field-group-type.enum';
import {Dictionary} from '@ngrx/entity';
import {IFieldType} from '../_interface/ifield-type';
import {FieldTypes} from '../_interface/field-types.enum';
import {isComplexFn, isComplexOrWidgetFn} from '../_reducers/isWhatType.fn';

export const entityState = createFeatureSelector<State>(featureKey);
export const selectAll = createSelector(entityState, adapter.getSelectors().selectAll);
export const fieldTypesLoaded = createSelector(entityState, ({loaded}) => loaded);
export const selectNonComplex = createSelector(
	selectAll,
		fieldTypes => fieldTypes.filter(item =>
			item.groupType !== FieldGroupTypeEnum.complex && item.groupType !== FieldGroupTypeEnum.drawing)
);

export const selectEntities = createSelector(entityState, adapter.getSelectors().selectEntities);
export const selectOneEntity = (id: string) => {
	return createSelector(selectEntities, (e: Dictionary<IFieldType>) => e[id]);
};

export const selectComplexProtoFieldTypeId = createSelector(
	selectAll,
	fieldTypes => fieldTypes.find(item =>
		item.groupType === FieldGroupTypeEnum.complex &&
		item.fieldType === FieldTypes.prototype
	)
);

export const selectComplexInstanceFieldTypeId = createSelector(
	selectAll,
	fieldTypes => fieldTypes.find(item =>
		item.groupType === FieldGroupTypeEnum.complex &&
		item.fieldType === FieldTypes.instance
	)
);

export const selectWidgetFieldTypeId = createSelector(
	selectAll,
	fieldTypes => fieldTypes.find(item =>
		item.fieldType === FieldTypes.widget
	)
);

export const selectSymbolFieldType = createSelector(
	selectAll,
	fieldTypes => fieldTypes.find(item =>
		item.fieldType === FieldTypes.symbol
	)
);

export const selectSchemaFieldType = createSelector(
	selectAll,
	(fieldTypes): IFieldType => fieldTypes.find(item =>
		item.fieldType === FieldTypes.schema
	)
);

export const selectComplexAndWidgetTypes = createSelector(
	selectAll,
	fieldTypes => fieldTypes.filter((f) => isComplexOrWidgetFn(f.fieldType as FieldTypes))
);

export const selectComplexTypes = createSelector(
	selectAll,
	(fieldTypes): IFieldType[] => fieldTypes.filter((f) => isComplexFn(f.fieldType as FieldTypes))
);
